import React from "react";

const AddPlusButton = ({ onClick, size }) => {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-1 rounded-md text-nowrap bg-[#0e1435] text-white ${
        size === "sm" ? "text-xs" : "text-sm"
      } scale-100 hover:scale-105 transition-all duration-300`}
    >
      +
    </button>
  );
};

export default AddPlusButton;
